module.exports = __webpack_public_path__ + "static/media/homeGif4.ecd31b22.gif";